import jwtDecode from 'jwt-decode';
import store from '../store';

/**
 * Extracts and validates access token from Redux store
 *
 * This utility ensures only access tokens are retrieved for microservice API calls.
 * It validates the token exists and attempts to decode it to verify it's a valid JWT.
 *
 * @returns {string|null} Access token string or null if not available/invalid
 */
export const getAccessToken = (): string | null => {
  const authState = store.getState().auth;

  if (!authState?.isAuthenticated || !authState.jwToken) {
    return null;
  }

  const token = authState.jwToken;

  try {
    // Decode the token to validate it's a valid JWT
    // If decoding fails, the token is invalid
    jwtDecode(token);
    return token;
  } catch (error) {
    // Token is invalid or not a JWT
    console.warn('Invalid token format:', error);
    return null;
  }
};
